
if(/Android/.test(navigator.userAgent)) {
  $('#lottery-form input').focus(function () {
      $('.lottry-box').css("top","0%");
  });
  
  $('#lottery-form input').blur(function () {
      $('.lottry-box').css("top","29%");
  });
}




$('.lottery-tab').click(function() {
    $('.lottry-box').toggleClass('active');
});

$('.icon-close').click(function() {
    closeLottery();
});

function showLottery() {
    $('.lottry-box').toggleClass('active');
    $('body').css("overflow","hidden");
}

function closeLottery() {
    $('.lottery-form-box').show();
    $('.lottery-success').hide();
    $('.success-title').empty();
    $('.success-describe').empty();
    $('.cuppon-code').empty();
    $('.lottry-box').removeClass('active');
    $('#lottery-submit').prop('disabled', false);
    $('#lottery-submit').removeClass('noclickable');
    $('.roulette-box .roulette').css("transform","rotate(0deg)").css("transition","transform 0s ease-out 0s");
    $('body').css("overflow","auto");
}

// 订阅提交
$("#lottery-form").submit(function (e) {
    $('#lottery-submit').prop('disabled', true);
    $('#lottery-submit').addClass('noclickable');
    e.preventDefault();
    $('.roulette-box .roulette').css("transform","rotate(18000deg)").css("transition","transform 30s ease-out 0s");
    
    // let res = {
    //     code: 1,
    //     msg: '',
    //     data: {
    //         title: 'Congrats! you won $5 off Accessory',
    //         describe: 'Best all terrain & off road electric scooters for adults:',
    //         couponCode: 'wyeudieu123',
    //         link: 'https://turboant.com/',
    //         index: 2,
    //         total: 8
    //     }
    // };
    // const { status, msg, data } = res;

    // let deg = 1800 + (360 / data.total) * data.index;
    
    // setTimeout(function () {
    //     $('.roulette-box .roulette').css("transform",`rotate(${deg}deg)`).css("transition","transform 3s ease-out 0s");
    // }, 4000);
    // setTimeout(function () {
    //     $('.lottery-form-box').hide();
    //     $('.lottery-success').show();
    //     $('.success-title').append(data.title);
    //     $('.success-describe').append(data.describe);
    //     $('.cuppon-code').append(data.couponCode);
    //     $('.shop-link').attr('href', data.link);
    // }, 7000);
    

    let host = 'https://backend.turboant.com';
    // 此处为请求
    $.ajax({
        // url: 'https://backend.turboant.com/index/api/dealshopifycustomer',
        url: host + '/index/api/turboantLottery',
        type: 'post',
        data: {
            account:'turboant.myshopify.com',
            email: $('#lottery-email').val(),
            name: $('#lottery-name').val(),
        },
        dataType: 'json',
        success: (res) => {
            const { code, msg, data } = res;
            if(code === 1){
                let deg = 1800 + (360 / data.total) * data.index;
    
                setTimeout(function () {
                    $('.roulette-box .roulette').css("transform",`rotate(${deg}deg)`).css("transition","transform 3s ease-out 0s");
                }, 0);
                setTimeout(function () {
                    $('.lottery-form-box').hide();
                    $('.lottery-success').show();
                    $('.success-title').append(data.title);
                    $('.success-describe').append(data.describe);
                    $('.cuppon-code').append(data.couponCode);
                    $('.shop-link').attr('href', data.link);
                }, 3000);
                
            }else{
                $('.lottry-box').append(`<div class='tb-toast black-friday-toast'>${msg}</div>`);
                $('.roulette-box .roulette').css("transform","rotate(0deg)").css("transition","transform 0s ease-out 0s");
                setTimeout(function () {
                $('.tb-toast').remove();
                }, 5000)
            }
        }
    });
  });